import {AxiosPromise} from "axios";
import {
  DsaResourceApi,
  DsaScreenAddDto,
  DsaBoardDto,
  DsaContentDto,
  DsaScreenDto,
  DsaPlaylistDto,
  ScreenConfigDto,
  SendDeviceComandDto,
  DsaScheduleDto,
  DsaScheduleEventDto,
  DsaDeleteScheduleEventDto,
  DsaScheduleRotationDto,
  DsaScheduleRenameDto
} from "../generated/dashboard-client";
import {dashboardApiConfig, ops} from "./config";

const api = new DsaResourceApi(dashboardApiConfig);

const DSAApi = {
  activateDevice(dto: DsaScreenAddDto): AxiosPromise<DsaScreenDto> {
    return api.addScreen(dto, ops());
  },

  getScreens(includeDetails: boolean): AxiosPromise<DsaScreenDto[]> {
    return api.getScreens(includeDetails, ops());
  },

  getScreensDetails(serials: string[]): AxiosPromise<DsaScreenDto[]> {
    return api.getScreensDetails(serials, ops());
  },

  deleteScreen(serial: string): AxiosPromise<void> {
    return api.deleteScreen(serial, ops());
  },

  getScreensTotal(): AxiosPromise<number> {
    return api.getScreensTotal(ops());
  },

  getDeactivatedScreensTotal(): AxiosPromise<number> {
    return api.getDeactivatedScreens(ops());
  },

  toggleLockScreen(serial: string): AxiosPromise<DsaScreenDto> {
    return api.toggleLockScreen(serial, ops());
  },

  updateScreen(serial: string, dto: DsaScreenAddDto): AxiosPromise<DsaScreenDto> {
    return api.updateScreen(serial, dto, ops());
  },

  updateScreenConfig(serial: string, dto: ScreenConfigDto): AxiosPromise<DsaScreenDto> {
    return api.updateScreenConfig(serial, dto, ops());
  },

  setScreenContent(serial: string, dto: DsaContentDto): AxiosPromise<DsaScreenDto> {
    return api.setScreenContent(serial, dto, ops());
  },

  removeScreenContent(serial: string): AxiosPromise<DsaScreenDto> {
    return api.removeScreenContent(serial, ops());
  },

  updateScreenContent(serial: string, dto: DsaContentDto): AxiosPromise<DsaScreenDto> {
    return api.updateScreenContent(serial, dto, ops());
  },

  sendDeviceCommand(serial: string, dto: SendDeviceComandDto): AxiosPromise<DsaScreenDto> {
    return api.sendDeviceCommand(serial, dto, ops());
  },

  createBoard(dto: DsaBoardDto): AxiosPromise<DsaBoardDto> {
    return api.createBoard(dto, ops());
  },

  getBoards(): AxiosPromise<DsaBoardDto[]> {
    return api.getBoards(ops());
  },

  getBoard(id: string): AxiosPromise<DsaBoardDto> {
    return api.getBoard(id, ops());
  },

  createPlaylist(dto: DsaPlaylistDto): AxiosPromise<DsaPlaylistDto> {
    return api.createPlaylist(dto, ops());
  },

  updatePlaylist(id: string, dto: DsaPlaylistDto): AxiosPromise<DsaPlaylistDto> {
    return api.updatePlaylist(id, dto, ops());
  },

  deletePlaylist(id: string): AxiosPromise<void> {
    return api.deletePlaylist(id, ops());
  },

  getPlaylist(id: string): AxiosPromise<DsaPlaylistDto> {
    return api.getPlaylist(id, ops());
  },

  toggleLockPlaylist(id: string): AxiosPromise<DsaPlaylistDto> {
    return api.toggleLockPlaylist(id, ops());
  },

  getPlaylists(): AxiosPromise<DsaPlaylistDto[]> {
    return api.getPlaylists(ops());
  },

  createSchedule(dto: DsaScheduleDto): AxiosPromise<DsaScheduleDto> {
    return api.createSchedule(dto, ops());
  },

  addScheduleEvent(id: string, dto: DsaScheduleEventDto): AxiosPromise<DsaScheduleEventDto> {
    return api.addScheduleEvent(id, dto, ops());
  },

  updateScheduleEvent(id: string, dto: DsaScheduleEventDto): AxiosPromise<DsaScheduleEventDto> {
    return api.updateScheduleEvent(id, dto, ops());
  },

  deleteSchedule(id: string): AxiosPromise<void> {
    return api.deleteSchedule(id, ops());
  },

  renameSchedule(id: string, name: string): AxiosPromise<DsaScheduleDto> {
    return api.updateScheduleName({id: id, newName: name} as DsaScheduleRenameDto, ops());
  },

  getSchedules(): AxiosPromise<DsaScheduleDto[]> {
    return api.getSchedules(ops());
  },

  deleteScheduleEvent(id: string, dto: DsaDeleteScheduleEventDto): AxiosPromise<DsaScheduleDto> {
    return api.deleteScheduleEvent(id, dto, ops());
  },

  toggleLockSchedule(id: string): AxiosPromise<DsaScheduleDto> {
    return api.toggleLockSchedule(id, ops());
  },

  getScheduleRotations(id: string): AxiosPromise<DsaScheduleRotationDto[]> {
    return api.getScheduleRotations(id, ops());
  },

  createScheduleRotation(dto: DsaScheduleRotationDto): AxiosPromise<DsaScheduleRotationDto> {
    return api.createScheduleRotation(dto, ops());
  },

  updateScheduleRotation(dto: DsaScheduleRotationDto): AxiosPromise<DsaScheduleRotationDto> {
    return api.updateScheduleRotation(dto.id!!, dto, ops());
  },

  deleteScheduleRotation(id: string): AxiosPromise<void> {
    return api.deleteScheduleRotation(id, ops());
  },

  getScreensPerLocation(locationId: number): AxiosPromise<DsaScreenDto[]> {
    return api.getScreensPerLocation(locationId, ops());
  },

  userHasScreens(): AxiosPromise<boolean> {
    return api.userHasScreens(ops());
  }
}

export default DSAApi;
